import React, { useEffect, useRef } from 'react';
import renderMathInElement from 'katex/dist/contrib/auto-render.js';
import 'katex/dist/katex.min.css';
import './math-tools.css';

export default function MathText({ children, className = '' }) {
  const ref = useRef(null);
  const text = String(children ?? '');
  useEffect(() => {
    // React owns the outer span; KaTeX owns only its text descendants.
    ref.current.textContent = text;
    renderMathInElement(ref.current, {
      delimiters: [{ left: '$$', right: '$$', display: true }, { left: '\\[', right: '\\]', display: true }, { left: '\\(', right: '\\)', display: false }, { left: '$', right: '$', display: false }],
      trust: false, throwOnError: false, strict: 'ignore', maxExpand: 100, maxSize: 10,
    });
  }, [text]);
  return <span ref={ref} className={`math-text ${className}`} />;
}
